<template>
  <div class="progress" v-show="show">
    <i class="el-icon-close" @click="onClose"></i>
    <div class="title">压缩包正在导入中，请稍后</div>
    <div class="name">{{ fileInfo.fileName }}</div>
    <el-progress
      :text-inside="true"
      :stroke-width="16"
      :percentage="progressInfo.percent"
      color="#FDF1F1"
      text-color="#646464"
      class="prgress-view"
    ></el-progress>
    <div class="tip">导入完成后可以在上传记录中查看历史结果</div>
  </div>
</template>
  
  <script>
export default {
  name: "",
  props: {
    progressInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    fileInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    importId: {
      type: String,
      default: ""
    }
  },

  components: {},

  data() {
    return {
      show: true,
    };
  },

  created() {},

  methods: {
    onClose() {
      this.show = false;
    }
  },
};
</script>
  
<style scoped lang='scss'>
.progress {
  width: 250px;
  height: 105px;
  background: #ffffff;
  box-shadow: 0px 3px 9px 0px rgba(0, 0, 0, 0.5);
  border-radius: 2px 2px 3px 3px;
  position: fixed;
  right: 8px;
  bottom: 100px;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  box-sizing: border-box;
  padding: 6px 12px;
  z-index: 1000;
  .el-icon-close {
    position: absolute;
    right: 12px;
    top: 12px;
    cursor: pointer;
  }

  .title {
    font-weight: 500;
    color: #646464;
    line-height: 24px;
  }

  .name {
    font-weight: 400;
    color: #646464;
    line-height: 24px;
  }

  .tip {
    font-size: 11px;
    font-weight: 400;
    color: #bdbdbd;
    line-height: 24px;
  }

  .prgress-view {
    margin: 4px 0;
    /deep/ .el-progress-bar__innerText {
      color: #646464 !important;
    }
  }
}
</style>
  